import React from 'react';
import ReactDOM from 'react-dom';
import LoggedInPage from './../core/LoggedInPage';
import AdminLayout from './../registration/AdminLayout';
import CoreAjax from '../../util/CoreAjax';
import HmAjax from '../../util/HmAjax';

const DEFAULT_REFRESH_INTERVAL_SECONDS = 30;

export default class ContestMonitor extends LoggedInPage{
  constructor(props){
    super(props)
    this.state = {
      dataLoaded:false,
      data:null,
      tableData:null,
      schoolDetails:null,
      lastSavedTime: 0,
      monitorReady: true
    };
    
    this.getTableData = this.getTableData.bind(this);

    this.duplicateEntryAllowed = (window.contest_reg_duplicates && window.contest_reg_duplicates["allowed"]) ? window.contest_reg_duplicates["allowed"] : false;
    this.duplicateLoginIds = new Set();
    this.duplicateLoginIdAction = (window.contest_reg_duplicates && window.contest_reg_duplicates["action"]) ? window.contest_reg_duplicates["action"].toLowerCase() : null;
  }

  componentDidMount(){
    this.checkScheduler();
  }

  checkScheduler(){
    const me = this;

    const success = (response) => {
     if(response && response.msg == "scheduler_running"){
      me.dataRefresher();
      me.getMonitorData();    
      me.setState({monitorReady: true});
    }else if(response && response.msg == "scheduler_not_running"){
      me.setState({monitorReady: false});
    }      
  }

  const failure = () => {
      console.error("error communicating scheduler status");
  }

  new HmAjax(this.getUrlFor("MONITOR_SCHEDULER_STATUS")).get(success, failure);
}


dataRefresher(){
  let me = this;
  const interval_seconds = (window.contest_monitor && !isNaN(window.contest_monitor["interval_in_seconds"])) ? window.contest_monitor["interval_in_seconds"] : DEFAULT_REFRESH_INTERVAL_SECONDS; 

  this.monitorRefresher = setInterval(() =>{
    me.getMonitorData();
  }, interval_seconds*1000);
}

componentWillUnmount() {
  if(this.monitorRefresher){
    console.log("Killing monitor refresher..");
    clearInterval(this.monitorRefresher);
  }   
}

getMonitorData(){
  let me = this;

  let success = (response) => {
    if(response && response.data){
      let tableData = me.processSchoolData(response.data.studentDetails) || null;

      me.setState({data:response.data,tableData:tableData,dataLoaded:true, lastSavedTime:response.lastSavedTime});
      if(ReactDOM.findDOMNode(me.refs.AdminTable)){
        if(typeof me.refs.AdminTable.refreshGrid === "function"){
         me.refs.AdminTable.refreshGrid(me.getTableData(), response.lastSavedTime);
       }
     }
   }   
 }

 let failure = (err) => {
   if(ReactDOM.findDOMNode(me.refs.AdminTable)){
    if(typeof me.refs.AdminTable.refreshGrid === "function"){
   //    me.refs.AdminTable.refreshGrid(me.state.lastSavedTime);
 }
}
console.error("Error occurred while getting monitor Data");
}


if(ReactDOM.findDOMNode(this.refs.AdminTable)){
  if(typeof this.refs.AdminTable.refreshGrid === "function"){
  //  this.refs.AdminTable.refreshGrid(0);
}
}

  new HmAjax(this.getUrlFor("GET_MONITOR_DATA").replace("{#contestId}",this.props.contestGrpId)).mask().get(success, failure);

}


processSchoolData(studentList){
  let me = this;
  if(studentList){
    let tableList = [];

    studentList.map((each,idx) =>{
      let student = {};

      student["Student Name"]=each["userName"];
      student["User ID"]=each["loginId"];

      student["Level"]=each["levelName"] || "N/A";
      student["Category"]= me.rb(each["roundName"]) || "N/A";
      student["Last Updated"]=!isNaN(each["lastUpdatedTime"]) ?  me.epochTimeFn(each["lastUpdatedTime"]) + " " + me.formatAMPM(each["lastUpdatedTime"],"N/A") : "N/A";

      student["Started on"]= !isNaN(each["startTime"]) ?  me.epochTimeFn(each["startTime"]) + " " + me.formatAMPM(each["startTime"],"N/A") : "N/A";
      student["Submitted on"]=!isNaN(each["submitTime"]) ?  me.epochTimeFn(each["submitTime"]) + " " + me.formatAMPM(each["submitTime"],"N/A") : "N/A";
      student["Questions viewed"]= !isNaN(each["questionsSeen"]) ? parseInt(each["questionsSeen"]) : 0;
      student["Questions attempted"]= !isNaN(each["questionsAttempted"]) ? parseInt(each["questionsAttempted"]) : 0;
      student["Elapsed time"]=!isNaN(each["timeSpent"]) ? Math.round(each["timeSpent"] / 60) + " mins" : "N/A";
      student["Time remaining"]=!isNaN(each["timeLeft"]) ? Math.round(each["timeLeft"] / 60) + " mins" : "N/A";
      student["IP address"]=each["ipAddress"] || "N/A";
      student["Sessions"]=!isNaN(each["sessions"]) ? parseInt(each["sessions"]) : 0;

      tableList.push(student);
    });

    return tableList;
  }

  return null;
}

renderJsonData(userList){
  let me = this;
  let tableData = [];

        /*if(me.duplicateLoginIdAction === "highlight"){
            userList = me.filterDuplicates(userList, true);
          }*/

          userList.map((userData,index)=>{

            tableData[index]={
            }

            tableData[index]["Student Name"]=userData["userName"];
            tableData[index]["Started on"]=userData["startedOn"];
            tableData[index]["Submitted on"]=userData["submittedOn"];
            tableData[index]["Questions viewed"]=userData["questionsViewed"];
            tableData[index]["Questions attempted"]=userData["questionsAttempted"];
            tableData[index]["Elapsed time"]=userData["elapsedTime"];       
            tableData[index]["Time remaining"]=userData["timeRemaining"];
            tableData[index]["IP address"]=userData["ipAddress"];
            //tableData[index]["userRefId"]=userData["userRefId"];
            // tableData[index]["checked"] = false;
            tableData[index]["duplicate"]= (me.duplicateLoginIdAction === "highlight" && userData["duplicate"]) ? userData["duplicate"] : false; 

          })
          return tableData;
        }

        filterDuplicates(userList, forceFilter=false){
          let me = this;

          if(!this.duplicateEntryAllowed || forceFilter){
            let uniqUserList = [];

            if(userList && userList.length > 0){
              let tempLoginSet = new Set();
              let uniqDefiners = ["ipAddress"];

              for(let i=0; i< userList.length; i++){
                let tmpUniqKey = "";
                try{
                  for(let k=0; k<uniqDefiners.length; k++){
                    if(uniqDefiners[k]){
                      if(~uniqDefiners[k].indexOf(">")){
                        let tmpDefinerArr = uniqDefiners[k].split(">");
                        if(tmpDefinerArr.length > 1){
                         tmpUniqKey += (userList[i][tmpDefinerArr[0]] && userList[i][tmpDefinerArr[0]][tmpDefinerArr[1]]) ? userList[i][tmpDefinerArr[0]][tmpDefinerArr[1]] : "";     
                       }else{
                         tmpUniqKey += (userList[i][tmpDefinerArr[0]]) ? userList[i][tmpDefinerArr[0]] : "";     
                       }
                     }else{
                      tmpUniqKey += (userList[i][uniqDefiners[k]]) ? userList[i][uniqDefiners[k]] : "";
                    }
                  }
                }
              }catch(e){
                console.error(e);
              }

              if(tmpUniqKey && tempLoginSet.has(tmpUniqKey.toLowerCase())){
               let userObj = {
                "loginId" : userList[i].loginId,
                "userId" : userList[i].userId,
                "userRefId" : userList[i].userRefId
              };

              userList[i].duplicate = true;    
              me.duplicateLoginIds.add(userObj);                    
            }else{
              userList[i].duplicate = false;
              uniqUserList.push(userList[i]);
              tempLoginSet.add(tmpUniqKey.toLowerCase());
            }
          }

          if(me.duplicateLoginIds.size > 0){
            me.deleteDuplicateLogins();
          }

          return (uniqUserList && uniqUserList.length > 0 && !this.duplicateEntryAllowed) ? uniqUserList : userList;
        }
      }
        //userList.sort((a, b) => (a.userName > b.userName) ? 1 : -1)
        return userList;
      }

      deleteDuplicateLogins(){
        let me=this;
        if(!this.duplicateEntryAllowed &&  this.duplicateLoginIds.size > 0){
          console.warn("IRREVERSIBLE ACTION: DELETING the Duplicate Logins ::", this.duplicateLoginIds);

          if(this.duplicateLoginIdAction === "force_delete"){
            let failure = (err) => {
              console.error(err);
            }

            let success = (resp) => {
              console.warn("Success :", resp);
            }

            let postData = {
             "userList": me.duplicateLoginIds,
             "userStatus": [me.tableStatus]
           }

           new CoreAjax(this.getUrlFor("DELETE_ACCOUNTS"),postData).post(success, failure);
         }else{
          console.warn("NOT DELETING THE ACCOUNTS  Since the chosen action is not 'force_delete' ");
        }
      }
    }

    getTableData(){
      return  {
        contestType:"MONITOR",
        data:this.state.tableData,
        pagination:true,
        pagePerPage:20,
        toolTipArr:[0,1,3,4,5,6,9,10,11]
      }
    }


    render(){
      let me=this;

      if(!this.state.monitorReady){
        return(
          <div className="monitornotavail">
          {this.reactHtmlParser(this.rb("label.monitor.not_ready"))}
          </div>
          )
        }else if(!this.state.dataLoaded){
          return(
          <div>
          {this.showLoader()}
          </div>
          )
        }
        else if(this.state.lastSavedTime){
          let data = this.state.data;

          return(
          <div id="contestmonitor">
          <h3>{this.rb("contest.monitor.title")}</h3>
          <div className="float-right lastupdated">
          Last updated on: <span>{this.epochTimeFn(this.state.lastSavedTime)}
          ,&nbsp;{this.formatAMPM(this.state.lastSavedTime)}</span>
          </div>
          <div className="clearfix"></div>
          <div className="userdetailsrow">


          <div className="row">
          <div className="col-sm-6 col-md-3 userstatus">
          <div>{this.rb("contest.monitor.noofstudents")}</div>
          </div>
          <div className="col-sm-6 col-md-3 userstatus">
          <div>{this.rb("contest.monitor.submit")}</div>
          </div>
          <div className="col-sm-6 col-md-3 userstatus">
          <div>{this.rb("contest.monitor.inprogress")}</div>
          </div>
          <div className="col-sm-6 col-md-3 userstatus">
          <div>{this.rb("contest.monitor.yettostart")}</div>
          </div>
          </div>

          <div className="row">
          <div className="col-sm-6 col-md-3 userstatus">
          <div className="moncnt studcnt1">
          <span>{data.allStudentCount}</span>
          </div>
          </div>
          <div className="col-sm-6 col-md-3 userstatus">
          <div className="moncnt studcnt2">
          <span>{data.completedCount}</span>
          </div>
          </div>
          <div className="col-sm-6 col-md-3 userstatus">
          <div className="moncnt studcnt3">
          <span>{data.activeStudentCount}</span>
          </div>
          </div>
          <div className="col-sm-6 col-md-3 userstatus">
          <div className="moncnt studcnt4">
          <span>{(data.allStudentCount - (data.activeStudentCount + data.completedCount))}</span>
          </div>
          </div>
          </div>
          </div>
        {/* <hr/> */}
        <div className="RegTable usermonitor" id="contmontable">
        <div className="RegFunc">
        <TempAdminLayout ref={"AdminTable"} data={this.getTableData()}/>
        </div>
        </div>
        </div>
        )
      }
    }
  }


  class TempAdminLayout extends AdminLayout{

    refreshGrid(data, updatedTime){
      this.tableData = data;
      this.setState({data:data, dataLoaded:true, lastUpdatedTime: updatedTime});
    }
    
  }


// WEBPACK FOOTER //
// ./src/views/contest/ContestMonitor.js